/* eslint-disable */
import React from 'react';
import { Container } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { SeoHead } from '../../components/SeoHead';
import { Link } from 'react-router-dom';
import B2bTariffsTable from '../b2bPage/B2bTariffsTable';

export default function B2BTariffsPage() {
  const { t } = useTranslation();

  return (
    <>
      <SeoHead fallbackTitle="220 km">
        <title>{t('b2bTariffs.title')} | 220-km.com</title>
        <meta name="description" content={t('b2bTariffs.title')} />
      </SeoHead>
      <Container style={{ marginTop: '130px', paddingBottom: '80px' }}>
        <div style={{ marginBottom: '20px' }}>
          <Link to="/b2b" style={{ color: '#C83DC5', textDecoration: 'none', fontSize: '14px' }}>
            ← {t('b2bHeader')}
          </Link>
        </div>
        <div style={{ marginTop: '20px' }}>
          <B2bTariffsTable />
        </div>
      </Container>
    </>
  );
}
